import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-p2-off-duty-data',
  templateUrl: './p2-off-duty-data.component.html',
  styleUrls: ['./p2-off-duty-data.component.css']
})
export class P2OffDutyDataComponent implements OnInit {
    public p2OffDutyDataKeyno: string;

    labourNo;

    public edit?: Edit;

    public selectListLabours: Item[] = [];

    public selectListOffDutyCodes: OffDutyCodeItem[] = [];

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.p2OffDutyDataKeyno = this.stateService.getStateParams()['p2_offdutydata_keyno'];
        this.labourNo = this.stateService.getStateParams()['labour_no'];
    }

    private async loadEdit() {
        if (!!this.p2OffDutyDataKeyno && !!this.labourNo) {
            this.edit = (await this.datatask.Post(574, {
                p2_offdutydata_keyno: this.p2OffDutyDataKeyno,
                labour_no: this.labourNo
            }))[0];
        }
    }

    private async loadLabours() {
        this.selectListLabours = await this.datatask.Post(101, { activestatus: 'ACT' });
    }

    private async loadOffDutyCodes() {
        this.selectListOffDutyCodes = await this.datatask.Post(314);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(575, this.edit))[0];

                if (response?.status_no !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.status_message
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(576, { p2_offdutydata_keyno: this.edit.p2_offdutydata_keyno }))[0];

                    if (response.status_no !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.status_message
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async autoPickFromToTime(what: any): Promise <void> {
        if (!!this.edit) {
            const response = await this.datatask.Post(578, {
                labour_no: this.edit.labour_no,
                datetime_from: this.edit.datetime_from,
                datetime_to: this.edit.datetime_to
            });

            if (what !== 'to') {
                if (response?.datetime_from > '') {
                    this.edit.datetime_from = response?.datetime_from;
                }
            }

            if (what !== 'from') {
                if (response?.datetime_to > '') {
                    this.edit.datetime_to = response?.datetime_to;
                }
            }
        }
    }

    public onChanged(_: string, id: keyof Edit) {
        if (!this.edit) return;

        switch (id) {
            case 'datetime_from':
                if (this.edit.datetime_from !== '1970.10.10 ') {
                    this.autoPickFromToTime('from');
                } else {
                    this.autoPickFromToTime('both');
                }
                break;
            case 'datetime_to':
                if (this.edit.datetime_to !== '1970.10.10 ') {
                    this.autoPickFromToTime('to');
                } else {
                    this.autoPickFromToTime('both');
                }
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadLabours();
        this.loadOffDutyCodes();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    p2_offdutydata_keyno: string;
    labour_no: string;
    offdutycode_keyno: string;
    datetime_from: string;
    datetime_to: string;
}

interface OffDutyCodeItem {
    offdutycode_keyno: string;
    offdutycode_name: string;
    background_color_hex: string;
    text_color_hex: string;
    orderby: number;
}
